var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kydt"},[(_vm.showList)?_c('list-Six-vue',{attrs:{"columnId":_vm.column_id},on:{"detail":_vm.detail}}):_vm._e(),(!_vm.showList)?_c('detailVue',{attrs:{"articleId":_vm.article_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }